// extracted by mini-css-extract-plugin
export const amountStep = "AmountStep__amountStep__7q7qA";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buttonWrapper = "AmountStep__buttonWrapper__hA0y5";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const redemptionAmountWrapper = "AmountStep__redemptionAmountWrapper__7hDO+";
export const regular = "400";
export const rewardBalance = "AmountStep__rewardBalance__uQOUt";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";